import { useSelector } from 'react-redux';
import { hasPurchaseMotionsFailedSelector, hasProductStatusFailedSelector, hasOwnershipStatusFailedSelector, hasPromotionsStatusFailedSelector, hasRequiredOnboardingStatusFailedSelector, hasMarketingContactsOnRenewalFailedSelector, hasNumContactsFailedSelector } from '../selectors/LoadingStateSelectors';
export const useErrorBanner = () => {
  var _activeError$banner;
  const hasPurchaseMotionsFailed = useSelector(hasPurchaseMotionsFailedSelector);
  const hasProductStatusFailed = useSelector(hasProductStatusFailedSelector);
  const hasOwnershipStatusFailed = useSelector(hasOwnershipStatusFailedSelector);
  const hasPromotionsStatusFailed = useSelector(hasPromotionsStatusFailedSelector);
  const hasRequiredOnboardingStatusFailed = useSelector(hasRequiredOnboardingStatusFailedSelector);
  const hasMarketingContactsOnRenewalFailed = useSelector(hasMarketingContactsOnRenewalFailedSelector);
  const hasNumContactsFailed = useSelector(hasNumContactsFailedSelector);

  // Priority order: highest to lowest priority
  const errorConditions = [{
    condition: hasProductStatusFailed,
    banner: {
      key: 'failedProductStatusBanner',
      title: 'failedProductStatusBanner.title',
      description: 'failedProductStatusBanner.description'
    }
  }, {
    condition: hasOwnershipStatusFailed,
    banner: {
      key: 'failedOwnershipStatusBanner',
      title: 'failedOwnershipStatusBanner.title',
      description: 'failedOwnershipStatusBanner.description'
    }
  }, {
    condition: hasPromotionsStatusFailed,
    banner: {
      key: 'failedPromotionsStatusBanner',
      title: 'failedPromotionsStatusBanner.title',
      description: 'failedPromotionsStatusBanner.description'
    }
  }, {
    condition: hasRequiredOnboardingStatusFailed,
    banner: {
      key: 'failedRequiredOnboardingStatusBanner',
      title: 'failedRequiredOnboardingStatusBanner.title',
      description: 'failedRequiredOnboardingStatusBanner.description'
    }
  }, {
    condition: hasMarketingContactsOnRenewalFailed,
    banner: {
      key: 'failedMarketingContactsOnRenewalBanner',
      title: 'failedMarketingContactsOnRenewalBanner.title',
      description: 'failedMarketingContactsOnRenewalBanner.description'
    }
  }, {
    condition: hasNumContactsFailed,
    banner: {
      key: 'failedNumContactsBanner',
      title: 'failedNumContactsBanner.title',
      description: 'failedNumContactsBanner.description'
    }
  }, {
    condition: hasPurchaseMotionsFailed,
    banner: {
      key: 'failedPurchaseMotionsBanner',
      title: 'failedPurchaseMotionsBanner.title',
      description: 'failedPurchaseMotionsBanner.description'
    }
  }];

  // Find the first error condition that is true (highest priority)
  const activeError = errorConditions.find(({
    condition
  }) => condition);
  return (_activeError$banner = activeError === null || activeError === void 0 ? void 0 : activeError.banner) !== null && _activeError$banner !== void 0 ? _activeError$banner : null;
};